import React from 'react';
import { Redirect, useLocation } from 'react-router';

import { useRouteParams } from 'src/hooks/useRouteParams';
import { useShowSubgraphInsightsUI } from 'src/lib/featureFlags';

import { OperationsPage } from '../operationsPage/OperationsPage';
import { insightsRouteConfig } from '../routes';

import { SubgraphInsightsPage } from './subgraphPage/SubgraphInsightsPage';

export const InsightsPage = () => {
  const { insightsTab } = useRouteParams(insightsRouteConfig);
  const location = useLocation();
  const showSubgraphInsights = useShowSubgraphInsightsUI();
  const isUnsupportedTab = insightsTab === 'subgraphs' && !showSubgraphInsights;

  if (!insightsTab || isUnsupportedTab) {
    return (
      <Redirect
        to={insightsRouteConfig.locationFrom({
          location,
          patch: { insightsTab: 'operations' },
        })}
      />
    );
  }

  // TODO: Remove this redirect once the legacy "fields" tab is no longer needed.
  if (insightsTab === 'fields') {
    return (
      <Redirect
        to={insightsRouteConfig.locationFrom({
          location,
          patch: {
            insightsTab: 'objectFields',
          },
        })}
      />
    );
  }

  // This page is only rendered for 'operations' and 'subgraphs' tabs.
  // The other tabs ('objectFields', 'inputFields', 'enumValues') are
  // currently using a `/insights/schema/:typeName.:fieldName` route, which
  // is routed by VariantLayout to the right page.  At some point we may
  // want to consolidate these routes and use this page for all insights tabs.
  return insightsTab === 'subgraphs' ? (
    <SubgraphInsightsPage />
  ) : (
    <OperationsPage />
  );
};
